import './reset.css'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { AppProviders } from '@/component/provider/AppProviders'
import { AppRoutes } from '@/routes/AppRoutes'
import { useGlobalAudio } from '@/hooks/useGlobalAudio'

function App() {
    const { i18n } = useTranslation()
    const { audioRef, audioSrc } = useGlobalAudio()

    useEffect(() => {
        document.documentElement.lang = i18n.resolvedLanguage === 'cn'
            ? 'zh-CN'
            : (i18n.resolvedLanguage || 'ko')
    }, [i18n.resolvedLanguage])

    return (
        <>
            <audio ref={audioRef} src={audioSrc} loop={true} />
            <AppProviders>
                <AppRoutes />
            </AppProviders>
        </>
    )
}

export default App
